export const calculateDiscountPercent = (price, salePrice) => {
  const basePrice = Number(price || 0);
  const discountedPrice = Number(salePrice || 0);
  if (basePrice <= 0 || discountedPrice <= 0) return 0;
  if (discountedPrice >= basePrice) return 0;
  return Math.round(((basePrice - discountedPrice) / basePrice) * 100);
};

